module.exports = __webpack_public_path__ + "img/icon-receipt.2173b8a4.svg";